import glamorous from 'glamorous';

export default glamorous.div({
  bottom: 0,
  left: 0,
  position: 'absolute',
  top: 0
});


// WEBPACK FOOTER //
// ./lib/components/content/Top.js